ck.addUrlParam = function(url, param, value, encode) {
    encode = !! encode;
    // Using a positive lookahead (?=\=) to find the
    // given parameter, preceded by a ? or &, and followed
    // by a = with a value after than (using a non-greedy selector)
    // and then followed by a & or the end of the string
    var val = new RegExp('(\\?|\\&)' + param + '=.*?(?=(&|$))'),
        qstring = /\?.+$/, urlSplit = "", anchor = "";

    //check to see if we have an anchor (#) tag
    if( url.indexOf("#") !== -1 ){
        urlSplit = url.split("#");
        url = urlSplit[0];
        anchor = urlSplit[1];
    }

    // Check if the parameter exists
    if (val.test(url)){
        // if it does, replace it, using the captured group
        // to determine & or ? at the beginning
        url = url.replace(val, '$1' + param + '=' + value);
    } else if (qstring.test(url)){
        // otherwise, if there is a query string at all
        // add the param to the end of it
        url += (encode) ? encodeURIComponent( '&' + param + '=' + value ) : '&' + param + '=' + value;
    } else{
        // if there's no query string, add one
        url += '?' + param + '=';
        url += encode ? encodeURIComponent(value) : value;
    }

    //now place our anchor if there was any to the end of the query string
    if( anchor !== "" ){
        url += "#"+anchor;
    }

    return url;
}